import React from 'react'
import { Outlet } from 'react-router-dom'
import { list, create, get, edit, remove, bulk_remove } from '../../../features/permissions/actions';

const index = () => {

    const page = "Permissions";
    return (
        <div style={{ height: '100%', paddingTop: "4rem" }}>
            <Outlet context={[{ page, list, create, get, edit, remove, bulk_remove }]} />
        </div>
    )
}

export default index